import React from 'react';
import { motion } from 'framer-motion';
import girlStanding from '../../../assets/images/about_screen/girl_standing.webp';
import roundedTextImage from '../../../assets/images/about_screen/rounded_text_image.png';
import { useMediaQuery } from 'react-responsive';
const IncrediblyProudSection = () => {
  const paragraphStyles = `text-secondary text-lg 2xl:text-2xl`;
  const isMobile = useMediaQuery({ query: '(max-width: 767px)' });

  return (
    <div className="w-full flex flex-col justify-between gap-14 md:gap-24 max-w-[1280px] mx-auto px-4 md:px-10 py-10 md:py-20 relative z-10">
      <div className="flex flex-col md:flex-row items-center gap-10 xl:gap-20">
        <div className="flex-[60%] relative">
          <div className="lg:absolute lg:-bottom-[400px] 3xl:-bottom-[500px] right-10">
            <motion.div
              initial={{ opacity: 0, x: isMobile ? 0 : -300 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 1, ease: 'easeInOut' }}
              viewport={{ once: true, amount: 0.3 }}
            >
              <img
                src={girlStanding}
                alt="Child smiling in Wasilla pediatric therapy session"
                className="w-[75vw] lg:min-w-[600px] 3xl:min-w-[750px]"
              />
            </motion.div>
          </div>
        </div>
        <div className="flex-[40%]">
          <h2 className="italic font-medium text-[32px] leading-[40px] lg:text-[40px] lg:leading-[50px] 2xl:text-[48px] text-primary 2xl:leading-[56px] mb-4">
            We are incredibly proud of the geographic region that we serve,
            proud of its people and the cultures of Alaska.”
          </h2>
          <p className={`${paragraphStyles} mb-6`}>
            We know its immense potential and believe we have a role to play in
            developing that potential. At the heart of this drive is the ability
            to make quality therapy accessible and attractive for all Alaskan
            children. We take great pride in serving the diverse cultures of
            Alaska and incorporating those cultures and ethics into our therapy
            practice.
          </p>
          <p className={paragraphStyles}>
            We offer our children and families a ‘timeless intelligence’ with
            our practitioners always seeking to stay current in research and
            therapy modalities but pulling from our heritage to future-proof our
            craft in order to serve our children. We believe in building long
            and trusted relationships through consistent high performance.
          </p>
        </div>
      </div>
      <div className="flex flex-col-reverse md:flex-row gap-10 xl:gap-20 items-center">
        <div className="flex-[42%]">
          <h4 className="text-3xl text-primary font-bold">
            OT/PT/ST Plays a crucial role in the healthcare of our children
          </h4>
          <p className={`${paragraphStyles} mt-4`}>
            Physical, occupational, and speech therapy are vital to a robust
            integrated healthcare ecosystem. Physical therapy helps restore
            mobility, strength, and function, aiding patient independence.
            Occupational therapy enhances autonomy in daily activities,
            supporting engagement in work, leisure, and self-care. Speech
            therapy is key for communication, cognitive-linguistic, and
            swallowing recovery. Together, they offer a holistic path to health
            and independence.
          </p>
        </div>
        <div className="flex-[58%]">
          <motion.div
            initial={{ opacity: 0, x: isMobile ? 0 : 300 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 1, ease: 'easeInOut' }}
            viewport={{ once: true, amount: 0.5 }}
          >
            <img
              src={roundedTextImage}
              alt="Occupational therapy benefits infographic in Wasilla"
              className="w-full"
            />
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default IncrediblyProudSection;
